import { useMemo } from "react";
import { API_BASE_URL } from "../config/api";
import useInfinitePaginated, { mergeBuckets } from "./useInfinitePaginated";

export const EMPTY_ACCOUNTS = {
  live: [],
  inactive: [],
  passed: [],
  failed: [],
};

export const mergeAccounts = mergeBuckets(
  ["live", "inactive", "passed", "failed"],
  (account) => account?.id ?? account?.account_code ?? account?.code,
);

export const flattenAccounts = (accounts = EMPTY_ACCOUNTS) =>
  ["live", "inactive", "passed", "failed"].flatMap((bucket) =>
    Array.isArray(accounts?.[bucket]) ? accounts[bucket] : [],
  );

export default function usePaginatedAccounts(options = {}) {
  const pagination = useInfinitePaginated({
    endpoint: `${API_BASE_URL}challenges/trader/accounts/`,
    initialData: EMPTY_ACCOUNTS,
    select: (response) => response?.results || EMPTY_ACCOUNTS,
    merge: mergeAccounts,
    ...options,
  });
  const allAccounts = useMemo(
    () => flattenAccounts(pagination.data),
    [pagination.data],
  );

  return { ...pagination, accounts: pagination.data, allAccounts };
}
